module.exports = __webpack_public_path__ + "img/customerLogo15.8bfdc41c.png";